module.exports = __webpack_public_path__ + "static/media/m_y_0.61b39a45.png";